import { Analytics } from "@blings/analytics-lib";
import packageJson  from "../../package.json";
import { rootStore } from "../store/root";
import { environment } from "../store/utils/consts";

export type AnalyticsEvents =
  | "render"
  | "extensionLoaded"
  | "scene"
  | "project";

export class ExtensionAnalytics {
  backend: Analytics;
  extensionVersion = packageJson.version;
  env: string;

  constructor() {
    this.env = environment === "development" ? "dev" : "master";
    this.backend = new Analytics("extension");
  }

  /**
   * Handles the logic to send the event to the backend
   * @param event contains the event that was triggered
   * @param properties? contains an object with extra information on the event
   */
  public async send(event: AnalyticsEvents, properties?: any) {
    const { selectedProjectId, selectedProject } = rootStore.projectStore;
    const eventProperties = ["render", "project", "scene"].includes(event)
      ? { pId: selectedProjectId, ...properties }
      : properties;
    const user = rootStore.authStore.userEmail;
    const domain = user.substring(user.indexOf("@") + 1);
    const groupId = (await rootStore.authStore.getGroupIds())?.[0];
    const data = {
      v: this.extensionVersion,
      user: user,
      account:
        properties?.account || selectedProject?.projectAccountId || groupId,
      AEv: rootStore.projectStore.AEVersion.trim(),
      e: this.env,
      ...eventProperties,
      internalUser: domain === "blings.io",
    };
    // console.log(event, data); // uncomment for debugging
    this.backend.report(event, data);
  }
}
